/**
 * SessionDetailsPanel Component
 *
 * Handles the session title, description, status, and filter badges.
 * Extracted from CommunityAuditDetailHeaderSection.tsx to reduce complexity and improve maintainability.
 */

import { AuditSessionStatusBadge } from '@internal-audit/components/AuditSessionStatusBadge';
import type { FlexibleAuditSession } from '@internal-audit/domain/graphql-types';
import { Heading } from '@soteria/design-system-ve';

import { FilterBadgeSection } from '../FilterBadgeSection';
import * as denseStyles from '../InformationDenseLayout.css';
import * as styles from '../styles';

interface SessionDetailsPanelProps {
  session: FlexibleAuditSession;
}

export function SessionDetailsPanel({ session }: SessionDetailsPanelProps) {
  return (
    <div className={styles.heroContentRight}>
      {/* Session Title */}
      <Heading className={styles.sessionTitle} level="h1">
        {session.name}
      </Heading>

      {/* Session Description */}
      {session.description && <div className={denseStyles.sessionDescription}>{session.description}</div>}

      {/* Badge and Progress Section */}
      <div className={denseStyles.badgeAndProgressSection}>
        <FilterBadgeSection session={session} />

        {/* Status Indicator */}
        <div className={denseStyles.inlineProgressSection}>
          <div className={denseStyles.statusIndicator}>
            <span className={denseStyles.progressLabel}>Status:</span>
            <AuditSessionStatusBadge status={session.status} />
          </div>
        </div>
      </div>
    </div>
  );
}
